import { AnyAction } from 'redux';
import { CheckoutActions } from '../checkout.actions';

export const fernabsatzReducer = function (
  sectionState: boolean | null = null,
  action: AnyAction,
): boolean | null {
  if (action.type === CheckoutActions.FERNABSATZ_CHANGED) {
    return action.payload;
  }
  return sectionState;
};
